// hooks/useTooltipEnabled.ts
import { useMemo } from 'react';
import useQueryParam from './useQueryParam';

function useTooltipEnabled(): boolean {
  const tooltipParam = useQueryParam('tooltip');

  return useMemo(() => tooltipParam === '1', [tooltipParam]);
}

export default useTooltipEnabled;
